import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminPowerOfAttorney = lazy(() => import("@/pages/admin/AdminPowerOfAttorney"));

export const Route = createFileRoute("/admin/fullmakter")({
  component: () => <AdminPowerOfAttorney />,
});
